import { PhoneType } from 'ui/Phone/types';

export const MAX_SELECT_HEIGHT = 260;
export const defaultNumber: PhoneType = { iso: '+93', countryCode: 'AF', mask: '##-###-####' };
